import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navigation } from '../components/Navigation';
import { HeroProduct } from '../components/HeroProduct';
import { ProductHighlight } from '../components/ProductHighlight';
import { ScienceSection } from '../components/ScienceSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { FAQSection } from '../components/FAQSection';
import { Footer } from '../components/Footer';
import { SideCart } from '../components/SideCart';
import { ChatBot } from '../components/ChatBot';
import { products } from '../data/products';
import { useCart } from '../context/CartContext';

export function HomePage() {
  const { isCartOpen, setIsCartOpen, cartItems, addToCart, updateQuantity, removeItem, cartItemsCount, forceRefreshKey } = useCart();
  const location = useLocation();

  useEffect(() => {
    // Check if there's a hash in the URL and scroll to it
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }, [location]);

  return (
    <div key={forceRefreshKey} className="min-h-screen bg-white overflow-x-hidden">
      <Navigation 
        onCartOpen={() => setIsCartOpen(true)} 
        cartItemsCount={cartItemsCount}
      />
      
      <HeroProduct />
      
      <section id="products">
        <ProductHighlight 
          key={`rush-${cartItemsCount}`}
          product={{
            ...products.rush,
            onAddToCart: (variantId) => addToCart(products.rush, 1, variantId)
          }} 
        />
        <ProductHighlight 
          key={`synaptiq-${cartItemsCount}`}
          product={{
            ...products.synaptiq,
            onAddToCart: (variantId) => addToCart(products.synaptiq, 1, variantId)
          }} 
          reverse 
        />
        <ProductHighlight 
          key={`vitra-${cartItemsCount}`}
          product={{
            ...products.vitra,
            onAddToCart: (variantId) => addToCart(products.vitra, 1, variantId)
          }} 
        />
      </section>
      
      <section id="science">
        <ScienceSection />
      </section>
      
      <TestimonialsSection />
      
      <FAQSection />
      
      <Footer />
      
      <SideCart 
        isOpen={isCartOpen}
        onClose={() => setIsCartOpen(false)}
        cartItems={cartItems}
        updateQuantity={updateQuantity}
        removeItem={removeItem}
      />

      <ChatBot />
    </div>
  );
}